import { render, staticRenderFns } from "./chat-messages.vue?vue&type=template&id=f3aed076&scoped=true"
import script from "./chat-messages.vue?vue&type=script&lang=js"
export * from "./chat-messages.vue?vue&type=script&lang=js"
import style0 from "./chat-messages.vue?vue&type=style&index=0&id=f3aed076&prod&lang=less"
import style1 from "./chat-messages.vue?vue&type=style&index=1&id=f3aed076&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3aed076",
  null
  
)

export default component.exports